import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Testbook from "../../assets/login/testbookimg.png";
import { IoClose } from "react-icons/io5";
import Lgin from "../../assets/login/loginlogo.svg";
import { showSuccess } from "../../_config/toastUtil"; // Removed showError
import { axiosRequest } from "../../_config/apiClient";

const Login = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");

    // State to hold field-based validation errors
    const [errors, setErrors] = useState({ identifier: "", password: "", general: "" });

    const handleLogin = async () => {
        let tempErrors = { identifier: "", password: "", general: "" };
        let isValid = true;

        // Field Validation
        if (!identifier.trim()) {
            tempErrors.identifier = "Email or Phone is required";
            isValid = false;
        } else {
            const isPhone = /^\d{10}$/.test(identifier);
            const isEmail = /^\S+@\S+\.\S+$/.test(identifier);
            if (!isPhone && !isEmail) {
                tempErrors.identifier = "Enter valid email or 10 digit phone number";
                isValid = false;
            }
        }

        if (!password.trim()) {
            tempErrors.password = "Password is required";
            isValid = false;
        }

        setErrors(tempErrors);
        if (!isValid) return;

        // const isPhone = /^\d{10}$/.test(identifier);
        const isEmail = (identifier);

        const payload = {
            password,
            loginType: isEmail ? identifier.trim() : null,
            // phone: isPhone ? identifier : null,
        };

        try {
            const { data, error, message } = await axiosRequest('post', "/user/userLogin", payload);
            if (!error) {
                localStorage.setItem("user", data.token);
                localStorage.setItem("profile", JSON.stringify(data));
                showSuccess("Login successful 🎉");
                onClose();
                navigate("/dashboard");
            }
            setErrors({ ...tempErrors, identifier: message || "Login faild Please Enter Currect Value" });
        } catch (err) {
            // Show API error under the identifier field or a general spot
            const msg = err.response?.data?.message || err.message || "Invalid credentials";
            setErrors({ ...tempErrors, identifier: msg });
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[999] px-4">
            <div className="w-full max-w-[1200px] py-6 px-4 sm:px-8 md:px-20 mx-auto rounded-[10px] bg-white relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 w-[24px] h-[24px] cursor-pointer flex items-center right-4 justify-center hover:text-gray-600 z-10 bg-white rounded-full p-1 border border-[#333333]"
                >
                    <IoClose className="text-[#333333] text-[20px]" />
                </button>

                <div className="bg-white h-[600px] overflow-y-auto w-full mx-auto rounded-2xl max-w-[1100px] items-center grid grid-cols-1 lg:grid-cols-2">
                    <div className="flex-1 p-0 md:pr-18 lg:pr-30 pl-0 md:pl-2">
                        <img src={Lgin} alt="BaapBola Logo" />

                        <div className="mt-10">
                            <h2 className="text-[23px] md:text-[28px] font-[600] text-[#333333] tracking-tight mb-2">
                                Student Exam Portal BaapBola
                            </h2>
                            <p className="text-[16px] text-[#33333399] tracking-tight font-[500] leading-[20px]">
                                Welcome to your exam portal
                            </p>
                        </div>

                        <div className="space-y-4 px-[10px] mt-10">
                            {/* Identifier Field */}
                            <div>
                                <label className="block text-[18px] font-[500] text-[#333333] tracking-tight mb-2">
                                    Email or Phone Number
                                </label>
                                <input
                                    type="text"
                                    value={identifier}
                                    onChange={(e) => {
                                        setIdentifier(e.target.value);
                                        if (errors.identifier) setErrors({ ...errors, identifier: "" });
                                    }}
                                    className={`w-full border-[2.1px] rounded-[4px] px-4 py-3 tracking-tight focus:ring-2 font-[500] outline-none transition-all ${errors.identifier ? "border-red-500 focus:ring-red-100" : "border-[#33333399] focus:ring-blue-500"
                                        }`}
                                />
                                {errors.identifier && (
                                    <p className="text-red-500 text-sm mt-1 font-[500]">{errors.identifier}</p>
                                )}
                            </div>

                            {/* Password Field */}
                            <div>
                                <label className="block text-[18px] font-[500] text-[#333333] tracking-tight mb-2">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => {
                                        setPassword(e.target.value);
                                        if (errors.password) setErrors({ ...errors, password: "" });
                                    }}
                                    className={`w-full border-[2.1px] rounded-[4px] px-4 py-3 tracking-tight focus:ring-2 font-[500] outline-none transition-all ${errors.password ? "border-red-500 focus:ring-red-100" : "border-[#33333399] focus:ring-blue-500"
                                        }`}
                                />
                                {errors.password && (
                                    <p className="text-red-500 text-sm mt-1 font-[500]">{errors.password}</p>
                                )}
                            </div>

                            <button
                                onClick={handleLogin}
                                className="w-full bg-[#4096F6] mb-0 hover:bg-blue-600 text-white font-semibold py-3 tracking-tight rounded-[8px] shadow-md transition-colors mt-2 cursor-pointer"
                            >
                                Login
                            </button>

                            <button className="mt-1 text-[18px] text-end font-[500] block ml-auto tracking-tight text-[#4096F6] cursor-pointer ">
                                Forgot Password
                            </button>
                        </div>

                        <p className="mt-8 text-[18px] font-[500] tracking-tight text-[#333333] mt-10">
                            Don't have an account?{" "}
                            <button className="text-[#4096F6] font-[500] hover:underline cursor-pointer ">
                                Sign Up
                            </button>
                        </p>
                    </div>

                    <div className="flex-1 relative hidden lg:flex items-center justify-center">
                        <img src={Testbook} alt="Banner" className="w-full h-full object-cover" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;